import { render, staticRenderFns } from "./PrevisaoGatilho.vue?vue&type=template&id=15969ac5&scoped=true"
import script from "./PrevisaoGatilho.vue?vue&type=script&lang=js"
export * from "./PrevisaoGatilho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15969ac5",
  null
  
)

export default component.exports